<!-- eslint-disable -->

<template>
	<div class="d-flex flex-column bg-white rounded-lg px-4">
		<div>
			<div class="text-center">
				<span class="text-gotham" style="font-size: 14px"
					>{{ language == "en" ? "Door Number" : "Nomor Pintu" }} :</span
				>
				<div class="door-number text-gotham-bold">
					{{ doorNumber }}
				</div>
			</div>
			<div class="py-4" style="justify-content:center;display: flex;margin: auto;">
				<Qrcode :value="blobUrl || qrCode" :isBase64="isBase64" />
			</div>
		</div>

		<div class="divider my-4"></div>

		<Collapsible
			visible
			id="howto"
			cta="orderstatus_action_openlocker_howto_toggle"
			:title="language == 'en' ? howToStep.title : howToStep.title_bahasa"
			:open="toogleHowto"
			@onClick="toogleHowto = !toogleHowto"
		>
			<HowTo :content="instruction" />
		</Collapsible>

		<div class="divider my-4"></div>

		<div class="text-center mx-6 mb-4">
			<button
				class="button rounded-lg py-3 text-gotham-bold"
				style="width: 90%;background-color: white;border: 1px solid #5e51a1;color:#5e51a1;position:relative"
				data-cta="orderstatus_action_openlocker_hera"
				@click="buttonContactSupport()"
			>
				{{ language == "en" ? "Need help? Contact HERA" : "Butuh bantuan? Hubungi HERA" }}
				<img src="@/assets/images/hera.svg" alt="hera" class="icon-hera-button">
			</button>
		</div>
	</div>
</template>
<script>
/* eslint-disable */

import Collapsible from "../components/Collapsible.vue";
import Qrcode from "../components/Qrcode.vue";
import HowTo from "../components/HowTo.vue";
import LocalStorage from '@/services/localstorage';
export default {
	components: { Collapsible, Qrcode, HowTo },
	data() {
		return {
			doorNumber: "",
			qrCode: "",
			isBase64: false,
			blobUrl: "",
			toogleHowto: true,
			howToStep: {
				description: "",
				description_bahasa: "",
				title: "",
				title_bahasa: "",
				value: ""
			},
			instruction: ""
		};
	},
	computed: {},
	mounted() {
		const query = this.$route.query;
		let order = this.$store.state.orderDetail; 
		if(order == null){
			order = LocalStorage.getOrderData();
			order = JSON.parse(order)
		}
		if(order){
			this.doorNumber = order?.mouth?.number;
			if(localStorage.getItem('isBase64') == "true"){
				this.blobUrl = localStorage.getItem('bloburl')
				this.isBase64 = true;
			}else{	
				if (order?.barcode?.qrcodeCustomerTake) {
					this.qrCode = order?.barcode?.qrcodeCustomerTake;
					this.isBase64 = false;
				}
			}
			this.howToStep = this.getPaxelBoxContentSetting("how_to_open_locker");
	
			this.instruction = this.howToStep.description_bahasa?.replaceAll(
				"{{door_number}}",
				this.doorNumber
			);
			if (this.language == "en") {
				this.instruction = this.howToStep.description?.replaceAll("{{door_number}}", this.doorNumber);
			}
		}
	},
	methods: {
		contactHera(url) {
			window.location.href = url;
		}
	}
};
</script>
<style scoped>
.door-number {
	font-size: 48px;
	color: #ff434f;
}
.divider {
	height: 1rem;
	background-color: #f9f9fb;
	margin-right: -1.5rem;
	margin-left: -1.5rem;
}
.text-16 {
	font-size: 16px;
}
</style>
